import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import ImageListItemBar from "@mui/material/ImageListItemBar";
import styled from "styled-components";
import { SoecoButton } from "../../components/SoecoButton";
import DeleteIcon from "@mui/icons-material/Delete";
import { ErrorRecord, Product } from "../../types";
import { Trash2 } from "lucide-react";

type Props = {
    images: File[];
    setImages: (images: File[]) => void;
    imageUrls: string[];
    setImageUrls: (imageUrls: string[]) => void;
    error: boolean;
    errors: ErrorRecord<Product>;
    defaultPicture?: boolean;
    setDefaultPicture?: (defaultPicture: boolean) => void;
    newImages?: File[];
    setNewImages?: (newImages: File[]) => void;
    newImageUrls?: string[];
    setNewImageUrls?: (newImageUrls: string[]) => void;
    combinedImageUrls: string[];
    changedProduct: Product;
    setChangedProduct: (product: Product) => void;
};

export const SoecoImageList = (props: Props) => {
    const handleImageDelete = (index: number) => {
        const imageUrl = props.combinedImageUrls[index];

        if (imageUrl.startsWith("blob:")) {
            // Det är en ny bild (blob URL)
            const newIndex = index - props.imageUrls.length; // Justera för att hitta rätt index i newImages

            const updatedFiles = [...(props.newImages ?? [])];
            updatedFiles.splice(newIndex, 1);
            props.setNewImages?.(updatedFiles); // Uppdatera bilderna i parent

            if (props.newImageUrls) {
                const updatedUrls = [...props.newImageUrls];
                updatedUrls.splice(newIndex, 1);
                props.setNewImageUrls?.(updatedUrls); // Uppdatera URL-listan i parent
            }
        } else {
            // Det är en gammal bild (permanent URL)
            const updatedOldUrlss = [...props.imageUrls];
            updatedOldUrlss.splice(index, 1);

            props.setImageUrls(updatedOldUrlss); // Uppdatera den gamla bilden i parent

            const updatedOldUrls = [...props.imageUrls];
            const oldUrl = updatedOldUrls.splice(index, 1)[0];

            // Extrahera den delen efter "/images/" i URL:en
            const match = oldUrl.match(/\/images\/([a-zA-Z0-9]+)/);
            if (match) {
                const imageId = match[1];

                if (props.changedProduct.imageUrls?.includes(imageId)) {
                    props.setChangedProduct({
                        ...props.changedProduct,
                        imageUrls: props.changedProduct.imageUrls.filter(url => url !== imageId),
                    });
                    // Add if not in list
                } else {
                    props.setChangedProduct({
                        ...props.changedProduct,
                        imageUrls: [...(props.changedProduct.imageUrls ?? []), imageId],
                    });
                }
            }
        }

        // Revoke object URL (endast för blob URLs)
        URL.revokeObjectURL(imageUrl);
    };

    return (
        <ImageListWrapper>
            <ImageList cols={1}>
                <>
                    {props.combinedImageUrls.map((imageUrl, index) => {
                        return (
                            <ImageListItem key={imageUrl}>
                                <img src={imageUrl} alt="image" />
                                <ImageListItemBarWrapper>
                                    <ImageListItemBar
                                        sx={{
                                            background:
                                                "linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, " +
                                                "rgba(0,0,0,0.3) 0%, rgba(0,0,0,0) 0%)",
                                        }}
                                        position="top"
                                        actionIcon={
                                            <SoecoButton
                                                onClick={() => handleImageDelete(index)}
                                                icon={true}
                                            >
                                                {/* Prompt are you sure you want to delete product? */}
                                                <Trash2 color="black" />
                                            </SoecoButton>
                                        }
                                    />
                                </ImageListItemBarWrapper>
                            </ImageListItem>
                        );
                    })}
                </>
            </ImageList>
        </ImageListWrapper>
    );
};

const ImageListWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 15px;
    margin-right: 15px;
    margin-top: 15px;
`;

const ImageListItemBarWrapper = styled.div`
    background: "linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, " +
        "rgba(0,0,0,0.3) 0%, rgba(0,0,0,0) 0%)";
`;
